import { CardAuthorizationsDetails } from 'core/tarjeta/components/CardAuthorizationsDetails/CardAuthorizationsDetails';
import { CardAuthorizationsFooter } from 'core/tarjeta/components/CardAuthorizationsFooter/CardAuthorizationsFooter';
import { CardAuthorizationsList } from 'core/tarjeta/components/CardAuthorizationsList/CardAuthorizationsList';
import { CardAuthorizationsContext } from 'core/tarjeta/contexts/CardAuthorizationsContext';
import { useContext } from 'react';
import { Alert, Col, Container, Row } from 'react-bootstrap';
import { LinkButton } from 'shared/components';

export const CardAuthorizationsPage = () => {
  const {
    authorizations,
    cardReport,
    goBack,
    goToAccountMovements,
    goToCardMovements,
    authSearch,
  } = useContext(CardAuthorizationsContext);

  return (
    <Container>
      {authorizations ? (
        <>
          <Row className="mb-3">
            <Col>
              <CardAuthorizationsDetails
                cardData={cardReport}
                goBack={goBack}
                goToAccountMovements={goToAccountMovements}
              />
            </Col>
          </Row>
          <CardAuthorizationsList
            authorizations={authorizations}
            goBack={authSearch ? goToCardMovements : goBack}
          />
          <CardAuthorizationsFooter
            isAuthSearch={authSearch}
            goBack={goBack}
            goToAccountMovements={goToAccountMovements}
          />
        </>
      ) : (
        <>
          <Row>
            <Col>
              <Alert className="text-center">
                No existen datos disponibles para su consulta.
              </Alert>
            </Col>
          </Row>
          <Row>
            <Col className="text-center">
              <LinkButton onClick={goBack}>Volver</LinkButton>
            </Col>
          </Row>
        </>
      )}
    </Container>
  );
};
